import { Stack, Text, Tabs, Alert } from '@mantine/core'
import { WidgetCard } from '@/components/ui'
import { IconUsersGroup, IconAlertTriangle, IconKey } from '@tabler/icons-react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'
import { PessoasTab } from './PessoasTab'
import { GruposTab } from './GruposTab'
import { ClientesOAuth2Tab } from './ClientesOAuth2Tab'

export function LdapAdmin() {
  const { user } = useAuthStore()

  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return (
    <Stack gap="md">
      <WidgetCard accent="primary" p="md">
        <Tabs defaultValue="pessoas">
          <Tabs.List>
            <Tabs.Tab value="pessoas" leftSection={<IconUsersGroup size={14} />}>
              Usuários do Diretório
            </Tabs.Tab>
            <Tabs.Tab value="grupos" leftSection={<IconUsersGroup size={14} />}>
              Grupos
            </Tabs.Tab>
            <Tabs.Tab value="oauth2" leftSection={<IconKey size={14} />}>
              Clientes OAuth2
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="pessoas" pt="md">
            <PessoasTab />
          </Tabs.Panel>

          <Tabs.Panel value="grupos" pt="md">
            <GruposTab />
          </Tabs.Panel>

          <Tabs.Panel value="oauth2" pt="md">
            <ClientesOAuth2Tab />
          </Tabs.Panel>
        </Tabs>
      </WidgetCard>
    </Stack>
  )
}
